<template>
  <div class="text-counter" v-bind:class="{'over': (wordCount - maxLength) > 0}">{{ wordCount }}/{{ maxLength }}文字以内</div>
</template>

<script>
  export default {
    name: 'TextCounter',
    props: {
      wordCount: Number,
      maxLength: Number
    },
    data () {
      return {
      }
    },
    mounted () {
    },
    computed: {
    }
  }
</script>
